import React, { memo, useState } from "react";
import "./CustomBookmark.css";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { BookmarkProps } from "./SaveBookmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmarkSlash, faBookmark } from "@fortawesome/pro-solid-svg-icons";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";

const RemoveSaveBookmark: React.FC<BookmarkProps> = memo((props) => {
    const [isHover, setIsHover] = useState(false);
    const { isMobile } = useDeviceDetect();
    const iconSize = isMobile ? PublicPortalTheme.icons.sizeM : PublicPortalTheme.icons.sizeL;
    const primaryColor = PublicPortalTheme.palette.primary.main;
    const errorColor = PublicPortalTheme.palette.error.main;

    if (!props.userId) {
        return null;
    }

    return (
        <Tooltip title={props.tooltipMessage}>
            <IconButton className="custom-bookmark-button" onClick={props.action} onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                {!isMobile && isHover ? (
                    <FontAwesomeIcon icon={faBookmarkSlash} color={errorColor} style={iconSize} />
                ) : (
                    <FontAwesomeIcon icon={faBookmark} color={primaryColor} style={iconSize} />
                )}
            </IconButton>
        </Tooltip>
    );
});

export default RemoveSaveBookmark;
